<script>
  import { onMount } from 'svelte';
  import { registerCallReceiver } from '$lib/websocket-client.js';
  import CallPhone from '../CallPhone.svelte';
  import CallVideo from '../CallVideo.svelte';
  import IncomingCallDialog from './IncomingCallDialog.svelte';
  import {
    acceptIncomingCall,
    activeCall,
    callNotice,
    closeActiveCall,
    dismissIncomingCall,
    incomingCall,
    receiveIncomingCall,
    rejectIncomingCall,
    showCallNotice,
    updateActiveCall
  } from './call-store.js';

  onMount(() => {
    const matchesCall = (call, event, { requireSession = false } = {}) => {
      if (call?.conversationId !== event?.conversationId) return false;
      if (requireSession && !call?.sessionId) return false;
      return !call?.sessionId || !event?.sessionId || call.sessionId === event.sessionId;
    };

    return registerCallReceiver({
      onIncomingCall: receiveIncomingCall,
      onCallAccepted: (conversationId, event) => {
        if (matchesCall($incomingCall, event)) {
          dismissIncomingCall();
          showCallNotice('Cuộc gọi đã được trả lời trên thiết bị khác.');
        }
        if ($activeCall?.conversationId !== conversationId) return;
        updateActiveCall({
          status: 'connecting',
          peerId: event.from,
          sessionId: event.sessionId,
          iceTransportPolicy: event.iceTransportPolicy,
          relayRequired: event.relayRequired
        });
      },
      onCallEnded: (conversationId, event) => {
        if (matchesCall($incomingCall, event)) dismissIncomingCall();
        if (matchesCall($activeCall, event, { requireSession: true })) {
          closeActiveCall({ notifyServer: false });
          showCallNotice(event?.reason || 'Cuộc gọi đã kết thúc.');
        }
      },
      onCallStatus: (conversationId, event) => {
        if ($activeCall?.conversationId !== conversationId) return;
        if (event.status === 'ringing') {
          updateActiveCall({
            status: 'ringing',
            sessionId: event.sessionId,
            iceTransportPolicy: event.iceTransportPolicy,
            relayRequired: event.relayRequired
          });
          return;
        }
        if (event.status === 'busy' || event.status === 'error') {
          closeActiveCall({ notifyServer: false });
          showCallNotice(event.message || 'Không thể bắt đầu cuộc gọi.', 'error');
        }
      }
    });
  });
</script>

{#if $incomingCall}
  <IncomingCallDialog call={$incomingCall} onAccept={acceptIncomingCall} onReject={() => rejectIncomingCall()} />
{/if}

{#if $activeCall?.callType === 'audio'}
  <CallPhone call={$activeCall} />
{:else if $activeCall?.callType === 'video'}
  <CallVideo call={$activeCall} />
{/if}

{#if $callNotice}
  <div class="call-notice {$callNotice.tone}">{$callNotice.message}</div>
{/if}

<style>
  .call-notice {
    position: fixed;
    z-index: 1200;
    top: max(1rem, env(safe-area-inset-top));
    left: 50%;
    max-width: min(90vw, 30rem);
    transform: translateX(-50%);
    padding: 0.7rem 1rem;
    border: 1px solid rgba(148, 163, 184, 0.3);
    border-radius: 999px;
    color: #0f172a;
    background: rgba(255, 255, 255, 0.92);
    box-shadow: 0 16px 40px rgba(2, 6, 23, 0.18);
    backdrop-filter: blur(18px);
    font-size: 0.78rem;
    font-weight: 600;
  }

  .call-notice.error {
    color: #991b1b;
    background: rgba(254, 242, 242, 0.95);
  }

  .call-notice.warning {
    color: #92400e;
    background: rgba(255, 251, 235, 0.95);
  }
</style>
